module.exports = __webpack_public_path__ + "img/dice-six.4764168a.svg";